import ActionTypes from './container/actionType';

const authReducers = (state = {
    userDetails: [],
    UserInfo: [],
    LoginSuccess: false,
    Googleloader: false,
    Fbloader: false,
    passCode: false,
    Loader: false,
    LoaderLogin: false,
    error: '',
    PassError: '',
    success: '',
    sentEmail: '',
    SharedData: [],
    EditData: []
}, action) => {
    switch (action.type) {
        case ActionTypes.EditProfile: {
            return state={
                ...state,
                EditData: action.payload
            }
        }
        case ActionTypes.AllSharedData: {
            return state={
                ...state,
                SharedData: action.paylaod
            }
        }
        case ActionTypes.PasswordRest: {
            return state = {
                ...state,
                sentEmail: action.payload
            }
        }
        case ActionTypes.AuthSuccess: {
            return state = {
                ...state,
                UserInfo: action.payload
            }
        }
        case ActionTypes.PasscodeError: {
            return state = {
                ...state,
                PassError: action.payload
            }
        }
        case ActionTypes.passCodeLoader: {
            return state = {
                ...state,
                passCode: !state.passCode,
            }
        }
        case ActionTypes.AuthFacebook: {
            return state = {
                ...state,
                LoginSuccess: !state.LoginSuccess,
                userDetails: action.payload
            };
        }
        case ActionTypes.LoginWithEmail: {
            return state = {
                ...state,
                LoginSuccess: !state.LoginSuccess,
                userDetails: action.payload
            };
        }
        case ActionTypes.LoadingFb: {
            return state = {
                ...state,
                Fbloader: !state.Fbloader
            }
        }
        case ActionTypes.loginLoader: {
            return state = {
                ...state,
                LoaderLogin: !state.LoaderLogin
            }
        }
        case ActionTypes.LoaderAccount: {
            return state = {
                ...state,
                Loader: !state.Loader
            }
        }
        case ActionTypes.AuthGoogle: {
            return state = {
                ...state,
                LoginSuccess: !state.LoginSuccess,
                userDetails: action.payload
            };
        }
        case ActionTypes.LoadingInstant: {
            return state = {
                ...state,
                Googleloader: !state.Googleloader
            }
        }
        case ActionTypes.LoginError: {
            return state = {
                ...state,
                error: action.payload
            }
        }
        case ActionTypes.AuthWithEmail: {
            return state = {
                ...state,
                success: action.payload
            }
        }
        default: { }
    }
    return state;
}
export default authReducers;


// WEBPACK FOOTER //
// ./src/reducers/authReducers.jsx